import {
  SET_COMPONENTS,
  OPEN_REGISTER_COMPONENT_DIALOG,
  CLOSE_REGISTER_COMPONENT_DIALOG,
  SET_SAVING_COMPONENT_FLAG_SUCCESS,
  SET_SAVING_COMPONENT_FLAG_RESET,
  SET_SAVE_COMPONENT_FAILED,
  SET_SAVE_COMPONENT_FAILED_RESET,
  SET_DELETE_COMPONENT_FAILED,
  SET_DELETE_COMPONENT_FAILED_RESET,
  SET_DELETE_COMPONENT_SUCCESS,
  SET_DELETE_COMPONENT_SUCCESS_RESET,
  SET_UPDATED_COMPONENT
} from "redux/constants/flowDesigner";

const initialState = {
  components: [],
  showRegisterComponentDialog: false,
  savingComponentFlagSuccess: false,
  saveComponentFailed: false,
  deleteComponentSuccess: false,
  deleteComponentFailed: false
};

const cxfComponents = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_COMPONENTS:
      return {
        ...state,
        components: payload
      };
    case OPEN_REGISTER_COMPONENT_DIALOG:
      return {
        ...state,
        showRegisterComponentDialog: true
      };
    case CLOSE_REGISTER_COMPONENT_DIALOG:
      return {
        ...state,
        showRegisterComponentDialog: false
      };
    case SET_SAVING_COMPONENT_FLAG_SUCCESS:
      return {
        ...state,
        savingComponentFlagSuccess: true
      };
    case SET_SAVING_COMPONENT_FLAG_RESET:
      return {
        ...state,
        savingComponentFlagSuccess: false
      };
    case SET_SAVE_COMPONENT_FAILED:
      return {
        ...state,
        saveComponentFailed: true,
        errorMessage: payload
      };
    case SET_SAVE_COMPONENT_FAILED_RESET:
      return {
        ...state,
        saveComponentFailed: false
      };
    case SET_DELETE_COMPONENT_SUCCESS:
      return {
        ...state,
        deleteComponentSuccess: true
      };
    case SET_DELETE_COMPONENT_SUCCESS_RESET:
      return {
        ...state,
        deleteComponentSuccess: false
      };
    case SET_DELETE_COMPONENT_FAILED:
      return {
        ...state,
        deleteComponentFailed: true
      };
    case SET_DELETE_COMPONENT_FAILED_RESET:
      return {
        ...state,
        deleteComponentFailed: false
      };
    case SET_UPDATED_COMPONENT:
      return {
        ...state,
        components: state.components.map((component) =>
          component.id === payload.id
            ? {
                ...component,
                ...payload
              }
            : component
        )
      };
  }
  return state;
};

export default cxfComponents;
